import { createContext } from 'react';
import { GoalMetric } from 'shared/types/goal-metric';
import { ID } from 'shared/types/id';

export type GoalProgressContextProps = {
  onOpenGoalProgressHistory: (goalId: ID, metric: GoalMetric) => void;
  onOpenGoalProgressAddEntry: (goalId: ID, metric: GoalMetric) => void;
};

export const GoalProgressContext = createContext<GoalProgressContextProps>({
  onOpenGoalProgressHistory: () => {},
  onOpenGoalProgressAddEntry: () => {},
});
